<template>
  <div class="maccontainer _maccontainer">
    <div :class="{ active: fixedTit }">
      <div class="navBg"></div>
      <div class="navcontainer _navcontainer">
        <div class="appleicon _appleicon">
          <img
            class="logo"
            :src="require('../../assets/luxuryArmourDoor/logo.png')"
          />
        </div>
        <div id="navID" class="mainnavlist _mainnavlist">
          <div
            @click="routerpush(item)"
            v-for="item in navList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <doorList :caseShow="caseShow" :secondNavList="secondNavList" :secondNavIndex="secondNavIndex" :newStyle="newStyle" @changeMenuIndex="changeMenuIndex" :startAnimate="animateFlag"></doorList>
  </div>
</template>

<script>
import doorList from "@/components/doorList";
export default {
  name: "luxuryArmourDoor",
  components: {
    doorList,
  },
  data() {
    return {
      menuIndex: 0,
      fixedTit: false,
      navList: [],
      selectNavName: null,
      secondNavList: [],
      secondNavIndex: 0,
      caseShow: false,
      animateFlag: false,
      newStyle: [
        {
          id: 1,
          name: "尊奢装甲门",
          title: "新款",
          img: require("../../assets/luxuryArmourDoor/newStyle.png"),
          listImg: [
            {
              id: 1,
              imgLink: require("../../assets/luxuryArmourDoor/luxuryArmourDoor1.jpg"),
              understand: true,
            },
            {
              id: 3,
              imgLink: require("../../assets/luxuryArmourDoor/luxuryArmourDoor3.jpg"),
              understand: false,
            },
            {
              id: 4,
              imgLink: require("../../assets/luxuryArmourDoor/luxuryArmourDoor4.jpg"),
              understand: false,
            },
            {
              id: 5,
              imgLink: require("../../assets/luxuryArmourDoor/luxuryArmourDoor5.jpg"),
              understand: false,
            },
            {
              id: 2,
              imgLink: require("../../assets/luxuryArmourDoor/luxuryArmourDoor2.jpg"),
              understand: false,
            },
            {
              id: 6,
              imgLink: require("../../assets/luxuryArmourDoor/luxuryArmourDoor6.jpg"),
              understand: false,
            },
          ],
        },
        {
          id: 2,
          name: "尊奢装甲门国潮",
          title: "新款",
          img: require("../../assets/door-gc/newStyle.png"),
          listImg: [
            {
              id: 1,
              imgLink: require("../../assets/door-gc/door-gc1.jpg"),
              understand: true,
            },
            {
              id: 4,
              imgLink: require("../../assets/door-gc/door-gc4.jpg"),
              understand: false,
            },
            {
              id: 3,
              imgLink: require("../../assets/door-gc/door-gc3.jpg"),
              understand: false,
            },
            {
              id: 5,
              imgLink: require("../../assets/door-gc/door-gc5.jpg"),
              understand: false,
            },
            {
              id: 6,
              imgLink: require("../../assets/door-gc/door-gc6.jpg"),
              understand: false,
            },
            {
              id: 2,
              imgLink: require("../../assets/door-gc/door-gc2.jpg"),
              understand: false,
            },
            {
              id: 7,
              imgLink: require("../../assets/door-gc/door-gc7.jpg"),
              understand: false,
            },
            {
              id: 8,
              imgLink: require("../../assets/door-gc/door-gc8.jpg"),
              understand: false,
            },
          ],
        },
        {
          id: 3,
          name: "尊奢装甲门国风",
          title: "新款",
          img: require("../../assets/luxuryArmourDoor/newStyle.png"),
          listImg: [
            {
              id: 1,
              imgLink: require("../../assets/door-gf/door-gf1.jpg"),
              understand: true,
            },
            {
              id: 3,
              imgLink: require("../../assets/door-gf/door-gf3.jpg"),
              understand: false,
            },
            {
              id: 4,
              imgLink: require("../../assets/door-gf/door-gf4.jpg"),
              understand: false,
            },
            {
              id: 5,
              imgLink: require("../../assets/door-gf/door-gf5.jpg"),
              understand: false,
            },
            {
              id: 2,
              imgLink: require("../../assets/door-gf/door-gf2.jpg"),
              understand: false,
            },
            {
              id: 6,
              imgLink: require("../../assets/door-gf/door-gf6.jpg"),
              understand: false,
            },
            {
              id: 7,
              imgLink: require("../../assets/door-gf/door-gf7.jpg"),
              understand: false,
            },
          ],
        },
      ],
    };
  },
  created(){
    this.getNavList()
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // this.caseShow = scrollTop > 300 && scrollTop < 1000 ? true : false
      this.fixedTit = scrollTop > 300 ? true : false;
    });
  },
  methods: {
    routerpush(to) {
      console.log(to)
      this.selectNavName = to.name
      this.secondNavIndex = 0
      this.getDoorBySeries(this.selectNavName)
      window.scrollTo(0, 0);
    },
    changeMenuIndex(data){
      this.secondNavIndex = data
      this.animateFlag = false
      this.getDoorList(this.secondNavList[this.secondNavIndex].id)
    },
    // 查询系列门接口
    getNavList() {
      this.$axios.get("/open/sale/webSiteSerialTypeList").then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data
          this.selectNavName = data[0]
          this.navList = data.map((item,index) => {
            return {name: item, id: index}
          })
          this.getDoorBySeries(this.selectNavName)
        }
      });
    },
    // 查询系列下面的门类型
    getDoorBySeries(doorName){
      this.$axios.get(`/open/sale/webSiteSerialDetailsList?seriesTypeName=${doorName}`).then(res =>{
        if(res.data.code === 0 && res.data.data.length > 0){
          this.secondNavList = res.data.data
          this.getDoorList(res.data.data[this.secondNavIndex].id)
        }
      })
    },
    getDoorList(id){
      this.$axios.get(`/open/sale/webSiteProductWindowPointList?productWindowId=${id}`).then(res =>{
        if(res.data.code === 0){
          this.newStyle = res.data.data
          this.animateFlag = true
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
// 头部开始
.active {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99999;
  box-shadow: 0px 0 15px #000;
  transition: all 0.3s cubic-bezier(0, 0, 0.5, 1);
}
// 大于800px
@media only screen and (min-width: 800px) {
  .navBg {
    height: 40px;
    background: #444;
  }
  .navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    background-color: rgb(51, 51, 51);
    color: rgb(214, 214, 214);

    .navicon {
      display: none;
      cursor: pointer;
    }

    .navicon:hover {
      color: white;
    }

    .appleicon {
      width: 100px;
      cursor: pointer;
      .logo {
        width: 30px;
        height: auto;
      }
    }

    .appleicon:hover {
      color: white;
    }

    .mainnavlist {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      max-width: 980px;
      width: 100%;

      .navlistclose {
        display: none;
      }

      div {
        text-align: center;
        height: 40px;
        line-height: 40px;
        width: 95px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
      }

      div:hover {
        color: white;
      }
    }

    .shopcar {
      width: 100px;
      cursor: pointer;
    }

    .shopcar:hover {
      color: white;
    }
  }
}

// 小于800px
@media only screen and (max-width: 800px) {
  ._navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    background-color: rgb(51, 51, 51);
    color: rgb(214, 214, 214);
    position: relative;

    ._navicon {
      width: 100px;
    }

    ._appleicon {
      width: 100px;
    }

    ._mainnavlist {
      display: flex;
      flex-direction: column;
      position: absolute;
      //屏幕宽度小于800，默认清空下菜单是关闭的
      display: none;
      position: fixed;
      left: 0;
      top: 0 !important;
      z-index: 1999 !important;
      padding-top: 40px !important;
      width: 100%;
      height: 100%;
      color: rgb(214, 214, 214);
      background-color: rgba(0, 0, 0, 0.95);
      top: 40px;
      padding: 0 40px;
      z-index: 999;

      div {
        text-align: left;
        height: 40px;
        line-height: 40px;
        width: 100%;
        border-bottom: 1px solid rgb(214, 214, 214);
      }
    }

    .shopcar {
      width: 100px;
    }
  }

  .navlistshow {
    display: block !important;
  }
}
// 头部结束

.color-ff6b00 {
  color: #ff6b00;
}

.color-f5f5f6 {
  background-color: #f5f5f6;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.newStyle {
  width: 1080px;
  margin: 0 auto;
  display: flex;

  & > div {
    flex: 1;
    padding-bottom: 15px;
    cursor: pointer;

    img {
      width: 90px;
      height: auto;
    }
  }

  & > div:hover {
    .hover-06c {
      color: #06c;
    }
  }

  & > div.active {
    .hover-06c {
      color: #06c;
    }
  }

  & > div:last-child {
    margin: 0;
  }
}

.bgHeight {
  height: 50px;
}

.doorList {
  .line {
    width: 100%;
    border-bottom: 7px solid #f5f5f6;

    img {
      width: 740px;
      height: auto;
    }

    .option {
      color: #0071e3;
      margin-bottom: 15px;
      cursor: pointer;
      flex-direction: column;

      .understand {
        font-size: 16px;
      }

      .arrow {
        width: 20px;
        height: 20px;
        font-size: 18px;
        margin-top: 9px;
        transform: rotate(90deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/luxuryArmourDoor/luxuryArmourDoor.vue